module.exports = __webpack_public_path__ + "img/trash_icon.612bdc4e.jpg";